import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { FundProjectionScreenOutlined, FundViewOutlined, TableOutlined } from '@vicons/antd';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 *
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/peoplesoftReport',
    name: 'peoplesoftReport',
   // redirect: '/report/view',
    component: Layout,
    meta: {
      title: 'Peoplesoft Report',
      icon: renderIcon(FundProjectionScreenOutlined),
      //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
      permissions: ['peoplesoft_invoice_read', 'peoplesoft_vendor_read','peoplesoft_gl_read'],
      sort: 8,
    },
    children: [
     
      {
        
        path: 'peoplesoft_invoice',
        name: 'peoplesoft_invoice',
        
        meta: {
          title: 'Peoplesoft Invoice',
          icon: renderIcon(FundViewOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['peoplesoft_invoice_read'],
          
          spname:'peoplesoft_invoice',
         
        },
        component: () => import('@/views/report/view/peoplesoftInvoice.vue'),
      },
      {
        
        path: 'peoplesoft_vendor',
        name: 'peoplesoft_vendor',
        
        meta: {
          title: 'Peoplesoft Vendor',
          icon: renderIcon(FundViewOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['peoplesoft_vendor_read'],
          
          spname:'peoplesoft_vendor',
         
        },
        component: () => import('@/views/report/view/peoplesoftVendor.vue'),
      },
      {
        
        path: 'peoplesoft_gl',
        name: 'peoplesoft_gl',
        
        meta: {
          title: 'Peoplesoft GL',
          icon: renderIcon(FundViewOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['peoplesoft_gl_read'],
          
          spname:'peoplesoft_gl',
         
        },
        component: () => import('@/views/report/view/peoplesoftGl.vue'),
      },
      
      
    ],
  },
];

export default routes;
